<template lang="pug">
.briq-form-element.briq-duration-input
  label(:for="name") {{ label }}
  briq-required-and-optional-markers(:isRequired="this.$attrs.required" :isDisabled="this.$attrs.disabled || this.$attrs.readonly" :hideOptionalMarker="hideOptionalMarker" :label="label")
  briq-tooltip(:help="help")
  VueTimepicker.time-picker(
    :format="format"
    v-model="innerValue"
    :hide-clear-button="hideClearButton"
    :placeholder="placeholderValue"
    v-bind="$attrs"
    manual-input
    close-on-complete
    )
    template(v-slot:clearButton)
      BriqIcon(name="icon-cross-error-icon")
  .form-help-text(v-if="infoText" v-html="infoText")
  .validation-message(v-if="error" :data-test-id="`validation-message-${this.$attrs['data-test-id']}`") {{ error }}
</template>

<script>
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import moment from 'moment'

export default {
  name: 'BriqDurationInput',
  components: { VueTimepicker },
  props: {
    name: String,
    label: String,
    value: String,
    help: String,
    error: String,
    hideOptionalMarker: {
      type: Boolean,
      default: false,
    },
    useInputInIsoFormat: Boolean,
    hideClearButton: Boolean,
    excludeSeconds: Boolean,
    placeholder: String,
    infoText: String,
  },
  data() {
    return {
      innerValue: null,
      innerValueIsoFormat: null,
    }
  },
  computed: {
    format() {
      return this.excludeSeconds ? 'HH:mm' : 'HH:mm:ss'
    },
    generatePlaceholder() {
      if (moment.duration(this.placeholder).toISOString() === this.placeholder) {
        const modelInMiliSeconds = moment.duration(this.placeholder)._milliseconds
        return moment.utc(modelInMiliSeconds).format(this.format)
      } else return this.placeholder
    },
    placeholderValue() {
      return this.placeholder ? this.generatePlaceholder : ''
    },
  },
  methods: {
    initValue() {
      if (!this.value) return null
      if (!this.useInputInIsoFormat) return this.stringToModel(this.value)
      else return this.isoToModel(this.value)
    },
    stringToModel(text) {
      const splits = text ? text.split(':') : ['00', '00', '00']
      return {
        HH: splits[0],
        mm: splits[1],
        ss: splits[2],
      }
    },
    isoToModel(text) {
      const modelInMiliSeconds = moment.duration(text)._milliseconds
      const milisecondsToTime = moment.utc(modelInMiliSeconds).format(this.format)
      return this.stringToModel(milisecondsToTime)
    },
    valueOrZero(key) {
      const val = this.innerValue ? this.innerValue[key] : null
      return val ? val : '00'
    },
    convertDataToIsoDuration(duration) {
      let durationObj = moment.duration(duration)
      let innerValueArr = []
      if (durationObj._data.hours > 0 || durationObj._data.minutes !== null) {
        innerValueArr.push('P')
      }
      if (durationObj._data.hours > 0 || durationObj._data.minutes !== null) {
        innerValueArr.push('T')
      }
      durationObj._data.hours > 0 ? innerValueArr.push(`${durationObj._data.hours}H`) : ''
      durationObj._data.minutes !== null ? innerValueArr.push(`${durationObj._data.minutes}M`) : ''
      return innerValueArr.join('')
    },
  },
  watch: {
    innerValue(newVal) {
      if (newVal === null || (newVal?.HH === '' && newVal?.mm === '')) {
        this.$emit('input', null)
        return
      }

      const toEmit = `${this.valueOrZero('HH')}:${this.valueOrZero('mm')}:${this.valueOrZero('ss')}`
      const toEmitInIso = this.convertDataToIsoDuration(toEmit)

      if (this.useInputInIsoFormat) this.$emit('input', toEmitInIso)
      else this.$emit('input', toEmit)
    },
    value(newVal) {
      if (!newVal) {
        this.innerValue = null
        return
      }
      const model = !this.useInputInIsoFormat
        ? this.stringToModel(newVal)
        : this.isoToModel(this.value)
      this.innerValue = model || null
    },
  },
  mounted() {
    this.innerValue = this.initValue()
  },
}
</script>

<style lang="stylus">
.briq-duration-input
  position relative

  .vue__time-picker.time-picker
    width 100%
    display block

    &:after
      display none

    input.display-time
      font-size 16px
      line-height 24px
      display block
      border solid 1px #ebebeb
      width 100%
      border-radius 4px
      padding 8px
      height auto
      background #fff

      &:disabled
        background #eee
        cursor not-allowed

    .clear-btn
      font-size 1em
      padding 0 0.7em
      height 100%

.form-help-text
  a
    font-weight 700
    text-decoration underline
</style>
